<template>
  <div class="np-status-page">
    <div class="np-status-card">
      <div class="np-status-icon is-error">
        <img src="@/assets/img/pay/error.png" alt="expired" />
      </div>
      <h1 class="np-status-title">Order expired</h1>
      <p class="np-status-desc">The order does not exist or has expired.</p>
      <div class="np-meta-chip">
        <span class="dot"></span>
        <span>Secure payment</span>
      </div>
      <div class="np-upi-bhim-logo">
        <img src="@/assets/img/pay/logo_upi_bhim.png" alt="UPI BHIM" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";

onMounted(() => {
  document.title = "NovaPay · Make money easily · TG@novapayruppe";
});
</script>
